import SEO from './seo';

export default SEO;
